import strings from "@/utils/strings";

export default [
	{
		title: strings.menu.home,
		route: "/",
		icon: "fa-home",
	},
	{
		title: strings.menu.install,
		route: "/install",
		image: require("@/assets/technician.svg"),
		component: import("@/components/misc/ControllerStatus"),
		tile: true,
		mobileOnly: true,
	},
	// {
	// 	title: strings.menu.project,
	// 	route: "/project",
	// 	image: require("@/assets/project-manager.svg"),
	// 	tile: true,
	// },
	{
		title: strings.menu.live,
		route: "/live",
		image: require("@/assets/liveview.svg"),
		tile: true,
	},
	// {
	// 	title: strings.menu.dashboard,
	// 	route: "/dashboard",
	// 	image: require("@/assets/dashboard.svg"),
	// 	tile: true,
	// },
	{
		title: strings.menu.k4noc,
		route: "/tickets",
		image: require("@/assets/noc.svg"),
		tile: true,
		flag: 'k4Noc'
	},
	{
		title: strings.menu.lock,
		route: "/lock-manager",
		image: require("@/assets/door.svg"),
		tile: true,
		mobileOnly: true,
	},
	{
		title: strings.menu.about,
		route: "/about",
		icon: "fa-info",
	},
	{
		title: strings.menu.logout,
		route: "/logout",
		icon: "fa-sign-out-alt",
	},
];
